import { queryHelpers, useMediaQuery } from '@leagueplatform/genesis-core';

/**
 * Onboarding is full-bleed through Genesis's mobile range (640px).
 * From mobileLandscape (641px), use the centered card on a grey surface.
 * Keep shell, content insets, and action widths on the same boundary.
 */
export const useIsOnboardingMobile = () =>
  useMediaQuery(queryHelpers.down('mobileLandscape'));
